import React from 'react'

const CertificateTemplate2 = ({
  studentName = 'Student Name',
  courseName = 'Course Name',
  date = 'Date',
  instituteName = 'Institute Name',
  certificateTitle = 'Certificate of Completion',
  authorityName = 'Director / Principal',
  logoUrl = '',
}) => {
  const handlePrint = () => {
    window.print()
  }

  return (
    <div className="certificate-template-2-page">
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Montserrat:wght@400;500;700&display=swap');

          .certificate-template-2-page {
            min-height: 100vh;
            background: linear-gradient(155deg, #0f172a 0%, #111827 42%, #1f2937 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 24px;
          }

          .certificate-template-2-wrap {
            width: min(980px, 100%);
          }

          .certificate-template-2-actions {
            display: flex;
            justify-content: center;
            margin-bottom: 16px;
          }

          .certificate-template-2-print-btn {
            border: 1px solid #d4af37;
            background: #111827;
            color: #f8eac2;
            padding: 10px 18px;
            border-radius: 999px;
            font-weight: 600;
            cursor: pointer;
            letter-spacing: 0.5px;
          }

          .certificate-template-2-card {
            position: relative;
            background: #fffdf8;
            border: 2px solid #c9a227;
            border-radius: 14px;
            padding: clamp(24px, 3.4vw, 42px);
            box-shadow: 0 22px 48px rgba(0, 0, 0, 0.34);
            overflow: hidden;
          }

          .certificate-template-2-card::before {
            content: '';
            position: absolute;
            inset: 14px;
            border: 2px dashed rgba(201, 162, 39, 0.7);
            border-radius: 8px;
            pointer-events: none;
          }

          .certificate-template-2-top {
            position: relative;
            z-index: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
          }

          .certificate-template-2-logo {
            width: 76px;
            height: 76px;
            border-radius: 10px;
            object-fit: cover;
            border: 2px solid #c9a227;
            background: #fff;
          }

          .certificate-template-2-medal {
            width: 84px;
            height: 84px;
            border-radius: 50%;
            background: radial-gradient(circle at 30% 30%, #f9de8f, #c7941d 66%, #9a6f0f 100%);
            color: #3b2b06;
            font-family: 'Montserrat', sans-serif;
            font-size: 10px;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 12px;
            border: 3px solid #f6e3a7;
          }

          .certificate-template-2-center {
            position: relative;
            z-index: 1;
            text-align: center;
            font-family: 'Montserrat', sans-serif;
            color: #1f2937;
            margin-top: 10px;
          }

          .certificate-template-2-institute {
            margin: 8px 0 0;
            font-size: clamp(20px, 3.2vw, 34px);
            font-weight: 700;
            text-transform: uppercase;
            color: #111827;
          }

          .certificate-template-2-script-title {
            margin: 10px 0 2px;
            font-size: clamp(40px, 6vw, 62px);
            font-family: 'Great Vibes', cursive;
            color: #8b5a00;
            font-weight: 400;
          }

          .certificate-template-2-caption {
            margin: 10px auto;
            max-width: 720px;
            line-height: 1.8;
            font-size: clamp(14px, 1.9vw, 18px);
          }

          .certificate-template-2-field {
            font-weight: 700;
            border-bottom: 2px solid #c9a227;
            padding: 0 6px 2px;
            color: #111827;
          }

          .certificate-template-2-footer {
            position: relative;
            z-index: 1;
            margin-top: 34px;
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 14px;
            font-family: 'Montserrat', sans-serif;
          }

          .certificate-template-2-sign {
            text-align: center;
          }

          .certificate-template-2-sign-label {
            margin-top: 26px;
            border-top: 1.8px solid #111827;
            padding-top: 8px;
            font-size: 12px;
            letter-spacing: 1px;
            text-transform: uppercase;
            font-weight: 700;
          }

          @media (max-width: 700px) {
            .certificate-template-2-top {
              flex-direction: column;
            }

            .certificate-template-2-footer {
              grid-template-columns: 1fr;
            }
          }

          @media print {
            body * {
              visibility: hidden;
            }
            .certificate-template-2-page,
            .certificate-template-2-page * {
              visibility: visible;
            }
            .certificate-template-2-page {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              background: #fff;
              min-height: auto;
              padding: 0;
            }

            .certificate-template-2-actions,
            .certificate-template-2-actions * {
              display: none !important;
              visibility: hidden !important;
            }

            .certificate-template-2-card {
              box-shadow: none;
              border-radius: 0;
            }
          }
        `}
      </style>

      <div className="certificate-template-2-wrap">
        <div className="certificate-template-2-actions">
          <button type="button" className="certificate-template-2-print-btn" onClick={handlePrint}>
            Print / Download
          </button>
        </div>

        <article className="certificate-template-2-card">
          <header className="certificate-template-2-top">
            {logoUrl ? (
              <img src={logoUrl} alt="Institute Logo" className="certificate-template-2-logo" />
            ) : (
              <div className="certificate-template-2-logo" />
            )}
            <div className="certificate-template-2-medal">CERTIFIED EXCELLENCE</div>
          </header>

          <section className="certificate-template-2-center">
            <h2 className="certificate-template-2-institute">{instituteName}</h2>
            <h1 className="certificate-template-2-script-title">{certificateTitle}</h1>
            <p className="certificate-template-2-caption">This certificate is proudly presented to</p>
            <p className="certificate-template-2-caption">
              <span className="certificate-template-2-field">{studentName}</span>
            </p>
            <p className="certificate-template-2-caption">
              for successful completion of
              {' '}
              <span className="certificate-template-2-field">{courseName}</span>.
            </p>
            <p className="certificate-template-2-caption">
              Issued on
              {' '}
              <span className="certificate-template-2-field">{date}</span>.
            </p>
          </section>

          <footer className="certificate-template-2-footer">
            <div className="certificate-template-2-sign">
              <div className="certificate-template-2-sign-label">Date: {date}</div>
            </div>
            <div className="certificate-template-2-sign">
              <div className="certificate-template-2-sign-label">{authorityName}</div>
            </div>
            <div className="certificate-template-2-sign">
              <div className="certificate-template-2-sign-label">{instituteName}</div>
            </div>
          </footer>
        </article>
      </div>
    </div>
  )
}

export default CertificateTemplate2
